import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { alpha, keyframes } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import circleLarge from '../../../../assets/alison-run/takeover-circle-1.svg';
import circleSmall from '../../../../assets/alison-run/takeover-circle-2.svg';
import star from '../../../../assets/alison-run/takeover-star.svg';
import { useAlisonRun } from '../AlisonRunProvider.js';
import { ALISON_DRAWER_WIDTH } from './AlisonRunDrawer.js';

const breathe = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.08); opacity: 1; }
`;
const TOPBAR_HEIGHT = 104;
const FOOTER_HEIGHT = 72;

export function AlisonTakeover(): ReactNode {
  const { drawerOpen, copy } = useAlisonRun();
  if (!drawerOpen) return null;
  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: { md: ALISON_DRAWER_WIDTH.md },
        overflow: 'hidden',
        zIndex: (theme) => theme.zIndex.drawer - 1,
        bgcolor: (theme) => alpha(theme.palette.background.default, 0.94),
        backdropFilter: 'blur(2px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pt: `${TOPBAR_HEIGHT}px`,
        pb: `${FOOTER_HEIGHT}px`,
      }}
    >
      <Box
        component="img"
        src={circleSmall}
        alt=""
        sx={{
          position: 'absolute',
          left: '-14.984px',
          top: '348.016px',
          width: 903.968,
          height: 903.968,
          maxWidth: 'none',
        }}
      />
      <Box
        component="img"
        src={circleLarge}
        alt=""
        sx={{
          position: 'absolute',
          left: '658.961px',
          top: '-385.039px',
          width: 1159.079,
          height: 1159.079,
          maxWidth: 'none',
        }}
      />
      <Stack sx={{ position: 'relative', alignItems: 'center', textAlign: 'center', gap: '16px' }}>
        <Box
          sx={{
            position: 'relative',
            width: 220,
            height: 220,
            animation: `${breathe} 2.4s ease-in-out infinite`,
          }}
        >
          <Box
            component="img"
            src={star}
            alt=""
            sx={{
              position: 'absolute',
              inset: '-66.36%',
              width: '232.72%',
              height: '232.72%',
              maxWidth: 'none',
            }}
          />
        </Box>
        <Stack sx={{ alignItems: 'center', gap: '16px' }}>
          <Typography
            sx={{ fontSize: 22, fontWeight: 500, lineHeight: '18.75px', color: 'background.icon' }}
          >
            {copy.takeoverHeadline}
          </Typography>
          <Typography
            sx={{
              maxWidth: 360,
              fontSize: 14,
              fontWeight: 400,
              lineHeight: 'normal',
              color: 'text.muted',
            }}
          >
            {copy.takeoverBody}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
